import { Box, Typography } from '@mui/material';
import { TypographySmallBold } from '../style/typography';

export default function PageLegend(props) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {props.legendItems.map((item, index) => (
        <Box
          key={index}
          sx={{
            backgroundColor: item.color,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: item.font_color,
          }}
        >
          <TypographySmallBold
            sx={{
              fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)' },
            }}
          >{item.label}</TypographySmallBold>
        </Box>
      ))}
    </Box>
  );
}
